<style lang="scss" scoped>
.navbar-light .navbar-nav .i-nav-link a {
    color: #616161 !important;
    font-weight: 500;
    padding: 3px 7px !important;
    font-size: 13px !important;
    border-radius: 3px;

    &:hover{
      // background: #e2ffe9;
      color: teal !important;
    }
    
}
.navbar-light .navbar-nav .i-nav-link.active a {
  color: white !important;
  font-weight: 500 !important;
  background: #00897B !important;
}
.navbar-nav{
  margin: 4px 0; 
  
}
.i-nav{
  font-family: 'Manrope';
  background-color: #FFF !important;
  border-bottom: 1px solid #dee2e6;
  &-wrapper{
    min-height: 44px;
  }
  &-logo{
    color: #16782e !important;
    min-height: 44px;
    & img{
      height:30px;
    }
  }
  &-link{
    margin-right: 7px;
    
    
  }
}
.notif{
  font-size: 12px;
  font-family: 'Manrope','Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: 600;
  letter-spacing: .3px;
  
  display: flex;
  justify-content: center;
  
    padding: 0px 50px;
  &__body{
    width:94%;
    display: flex;
    align-items: center;
  }

  &--danger, &--warning{
    background: #ffeeb6;
    color:#7e6000 ;
    border: 1px solid #ffdf76;

  }
}

.countdown{
  background: #fff1c3;
  margin-left: 20px;
  padding: 0 10px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  display: flex;
  align-items: center;
  border-left: 1px solid #ffdd6f;
  border-right: 1px solid #ffdd6f;
  &__item{
    // border-radius: 2px;
    
    // margin: 2px;
    padding: 5px 0 7px 0;
    min-width: 40px;
    // background: #FFAB00;
    color: #6a4700;
    position: relative;

    &:not(:last-child)::after{
      position: absolute;
      right: 0;
      top: 25%;
      content: "";
      height: 25px;
      width: 1px;
      border-right: 1px solid #e3dabd;
    }
  }
  & .time-field{
    text-align: center;
    font-size: 10px;
    font-weight: 400;
  }
  & .time-value{
    text-align: center;
    font-size: 18px;
    line-height: 1;
  }
  
}
.user{
  &__role{
    font-family: 'Manrope';
    font-weight: 500;
    font-size: 13px;
    color: #535353;

    display: flex;
    align-items: center;
    margin-right:10px;
    padding: 0px 10px;
    text-align: right;
    height: 30px;
    border-right: 1px solid rgb(224, 224, 224);
    line-height: 1.2;
  }
}
</style>
<style>
@media screen and (max-width: 600px) {
  .navbar-nav  .dropdown{
      display: block;
    
  }
  .user__role{
    display: none !important;
  }
  .dropdown-toggle{
    padding: 0.25rem .5rem !important;
    margin-top: 20px;
    
  }
  .navbar-nav  .dropdown-menu{
    top:40px;
    /* border-top:1px solid white; */
    box-shadow: none !important;
    border-bottom:none;
    border-top:none;
    font-size:12px;
    
  }
}

.navbar-nav  .dropdown-menu{
    top:40px;
    /* border-top:1px solid white; */
    box-shadow: rgba(17, 17, 26, 0.1) 0px 0px 16px;
    border-top:none;
    font-size:12px;
  
}
.navbar-nav  .dropdown-menu .dropdown-item{
    font-size:13px;
    display: flex;
    align-items: center;
    color: #4e4e4e !important;
    padding: 0.25rem 1rem;
    font-weight: 500;
    text-align: left;
}
.navbar-nav  .dropdown-menu .dropdown-header{
    font-size:12px;
    color: #a7a7a7 !important;
    padding: 0.6rem 1rem 0.25rem 1rem;
    font-weight: 500;
}
</style>
<template>
  <div id="navbar-ms">
    <div class="i-nav-wrapper">
      <b-navbar toggleable="lg" class="fixed-top i-nav">
        <b-container fluid>
          <b-navbar-brand to="/" class="i-nav-logo my-0 py-1">
            <div class="d-flex align-items-center px-2 py-0 my-0 ">
              <div class="mr-1">
                <b-img src="/img/logo-2.svg" fluid alt="Responsive image"></b-img>
              </div>
              <div >
                <div style="font-size:16px;font-weight:700;letter-spacing:1px">INDAH</div>
                <div style="font-size:11px;font-weight:600;margin-top:-6px">Indonesia Data Hub</div>
              </div>
            </div>
          </b-navbar-brand>
          <b-navbar-toggle target="nav-collapse" class="mr-2 button button--action button--outlined">
            <template #default="{ expanded }">
              <b-icon v-if="expanded" icon="x"></b-icon>
              <b-icon v-else icon="list"></b-icon>
            </template>
          </b-navbar-toggle>
          <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav>
              <b-nav-item to="/metadata-dashboard"         :class="$route.path =='/metadata-dashboard' ? 'i-nav-link active':'i-nav-link'">Beranda</b-nav-item>
              <b-nav-item href="/metadata/usulan-metadata" v-if="isSuperAdmin || isProdusenData || isWalidata" :class="$route.path =='/metadata/usulan-metadata' ? 'i-nav-link active':'i-nav-link'"  >Entri Pelaporan</b-nav-item>
              <b-nav-item to="/metadata/summary"           v-if="isSuperAdmin || isProdusenData || isWalidata" :class="$route.path =='/metadata/summary' ? 'i-nav-link active':'i-nav-link'"          >Daftar Pelaporan</b-nav-item>
              <b-nav-item to="/metadata/pemeriksaan"       v-if="isPembinaData" :class="$route.path =='/metadata/pemeriksaan' ? 'i-nav-link active':'i-nav-link'">Pemeriksaan</b-nav-item>
              <b-nav-item to="/metadata/report"            v-if="isPembinaData" :class="$route.path =='/metadata/report' ? 'i-nav-link active':'i-nav-link'">Report</b-nav-item>
              <b-nav-item to="/metadata/pengaturan/mutasi-produsen-kegiatan" v-if="canAccessMutasiProdusen" :class="$route.path =='/metadata/pengaturan/mutasi-produsen-kegiatan' ? 'i-nav-link active':'i-nav-link'">Mutasi Produsen</b-nav-item>
              <b-nav-item to="/metadata/pengaturan/recycle-kegiatan" v-if="canAccessMutasiProdusen" :class="$route.path =='/metadata/pengaturan/recycle-kegiatan' ? 'i-nav-link active':'i-nav-link'">Recycle Kegiatan</b-nav-item>
              <b-nav-item to="/metadata/panduan"           :class="$route.path =='/metadata/panduan' ? 'i-nav-link active':'i-nav-link'">Panduan</b-nav-item>
              <!-- <b-nav-item to="/metadata/pengaturan"        v-if="isPembinaData || isWalidata" :class="$route.path =='/metadata/pengaturan' ? 'i-nav-link active':'i-nav-link'">Pengaturan</b-nav-item> -->
            </b-navbar-nav>
            <b-navbar-nav
              v-if="user"
              class="ml-auto"
            >        
              <!-- <Treeselect 
                :clearable="false"
                v-model="currentRole"
                placeholder="Input Mode"
                :options="[{id:0, label:'Entri Mode'},{id:1, label:'Kuesioner Mode'}]"
              /> -->
              <input v-model="currentRole">
              <div class="user__role d-block">
                <div class="text-11 text-600">{{userRole}}</div>
                <div class="text-12 text-semi-bold">{{user.organization.name}}</div>
              </div>
              <b-dropdown
                right
                size="sm"
                variant="logout"
                toggle-class="d-flex align-items-center text-primary"
              >
                <template #button-content>
                  {{$store.getters['auth/user'].name}}
                </template>
                <!-- <b-dropdown-item to="/profile">
                  <VueFeather type="user" size="14"></VueFeather>&nbsp; Profil
                </b-dropdown-item> -->
                <b-dropdown-item 
                  to="/profile/change-password"
                  v-if="user.email.split('@')[1] != 'bps.go.id'"
                ><VueFeather type="shield" size="14"></VueFeather>&nbsp; Ubah Password</b-dropdown-item>
                
                <b-dropdown-group id="dropdown-group-1" header="Pengaturan" v-if="isSuperAdmin || isPembinaData || isWalidata">
                  <b-dropdown-item to="/pengaturan/user" v-if="isSuperAdmin">
                    <VueFeather type="users" size="14" ></VueFeather>&nbsp; User
                  </b-dropdown-item>
                  <b-dropdown-item to="/pengaturan/sdi/organization" v-if="isSuperAdmin || isPembinaData || isWalidata">
                    <VueFeather type="briefcase" size="14"></VueFeather>&nbsp; Organisasi SDI
                  </b-dropdown-item>
                  <b-dropdown-item to="/metadata/pengaturan/mutasi-produsen-kegiatan" v-if="canAccessMutasiProdusen">
                    <VueFeather type="repeat" size="14"></VueFeather>&nbsp; Mutasi Produsen
                  </b-dropdown-item>
                  <b-dropdown-item to="/metadata/pengaturan/recycle-kegiatan" v-if="canAccessMutasiProdusen">
                    <VueFeather type="refresh-cw" size="14"></VueFeather>&nbsp; Recycle Kegiatan
                  </b-dropdown-item>
                </b-dropdown-group>
                
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item to="/logout"><VueFeather type="power" size="14"></VueFeather>&nbsp; Keluar</b-dropdown-item>
              </b-dropdown>
            </b-navbar-nav>

            <b-navbar-nav v-else class="ml-auto">
              <b-button
                variant="login"
                size="sm"
                type="submit"
                to="/login"
                class="btn-login"
                >Masuk</b-button
              >
            </b-navbar-nav>
          </b-collapse>
        </b-container>
        
      </b-navbar>
      
    </div>
    <div class="notif notif--warning" v-if="isDeadlineSubmissionWarnShowed">
      <div class="notif__body">
        <!-- <div class="mr-2"><VueFeather type="alert-circle" size="20" style="display:block"></VueFeather></div> -->
        <div style="line-height:1.3">
          Kepada para pengguna, diinformasikan bahwa entri usulan baru dan pemutakhiran untuk penetapan SDSN tahun 2022 
          akan ditutup pada tanggal <u>{{deadlineDate.toLocaleDateString(locale, localeOptions)}}</u>. Segera submit usulan Anda..
        </div>
        
      </div>
      <div class="countdown" v-if="countdown">
          <div class="countdown__item">
            <div class="time-field">hari</div>
            <div class="time-value">{{countdown[0]}}</div>
          </div>
          <div class="countdown__item">
            <div class="time-field">Jam</div>
            <div class="time-value">{{countdown[1]}}</div>
          </div>
          <div class="countdown__item">
            <div class="time-field">Menit</div>
            <div class="time-value">{{countdown[2]}}</div>
          </div>
          <div class="countdown__item">
            <div class="time-field">Detik</div>
            <div class="time-value">{{countdown[3]}}</div>
          </div>
        </div>
    </div>
  </div>
  
</template>
<script>
import "@/assets/scss/main.scss";
import SettingService from '@/services/SettingService.js'
import * as role from "@/views/ms/SdiRole";
import VueFeather from 'vue-feather';
export default {
  components:{
    VueFeather
  },
  props: {
    currentRole:{
      type: String
    },
    roles:{
      type: Array
    },
  },
  data() {
    return {
      openMegaMenu: false,
      user:null,
      userRoles:[],
      deadlineDate: null,
      currentDate:null,
      locale : 'id-ID',
      localeOptions:{
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric"
      },
    };
  },
  computed:{

    countdown(){
      if(this.deadlineDate){
        let now = this.currentDate.getTime();
        let distance = this.deadlineDate.getTime() - now;
        let days = Math.floor(distance / (1000 * 60 * 60 * 24));
        let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((distance % (1000 * 60)) / 1000);
        return [days, hours,minutes,seconds]
      }else{
        return null;
      }
    },
    isSuperAdmin(){
      return role.isSuperAdmin(this.userRoles);
    },
    isPembinaData(){
      return role.isPembinaData(this.userRoles);
    },
    isWalidata(){
      return role.isWalidata(this.userRoles);
    },
    isProdusenData(){
      return role.isProdusenData(this.userRoles);
    },
    canAccessMutasiProdusen(){
      if (this.isSuperAdmin) return true;
      const roles = this.userRoles || [];
      const user = this.user || {};
      const isSuperAdmin =
        role.isSuperAdmin(roles) ||
        roles.includes('ROLE_SUPERADMIN') ||
        roles.includes('ROLE_ADMIN');
      const isPembinaPusat =
        role.isPembinaDataPusat(roles) ||
        roles.includes('ROLE_PEMBINA_DATA_PUSAT');
      const isSpecialUser =
        user.email === 'brian.firdian@gmail.com' ||
        user.email === 'brianf@bps.go.id';
      return isSuperAdmin || isPembinaPusat || isSpecialUser;
    },
    isDeadlineSubmissionWarnShowed(){
      if(this.deadlineDate){
        let daysDifference = (this.deadlineDate.getTime() - this.currentDate.getTime()) / (1000 * 3600 * 24);
        return this.currentDate >= this.deadlineDate || daysDifference>7 ? false : true
      }
      else{
        return false;
      }
    },
    isNotifShowedInPage(){
      let excludePages = ['/metadata/panduan'];
      return excludePages.includes(this.$route.path) ? false : true
    },
    userRole(){
      if(this.userRoles.includes('ROLE_SDS_ADMIN')){
        return 'Admin SDS'
      }
      else if(this.userRoles.includes('ROLE_PEMBINA_DATA_PUSAT')){
        return 'Pembina Data Pusat'
      }
      else if(this.userRoles.includes('ROLE_PEMBINA_DATA_PROVINSI')){
        return 'Pembina Data Provinsi'
      }
      else if(this.userRoles.includes('ROLE_PEMBINA_DATA_KABKOTA')){
        return 'Pembina Data Kabupaten/Kota'
      }

      else if(this.userRoles.includes('ROLE_WALIDATA_PUSAT')){
        return 'Walidata Pusat'
      }
      else if(this.userRoles.includes('ROLE_WALIDATA_PROVINSI')){
        return 'Walidata Provinsi'
      }
      else if(this.userRoles.includes('ROLE_WALIDATA_KABKOTA')){
        return 'Walidata Kabupaten/Kota'
      }

      else if(this.userRoles.includes('ROLE_PRODUSEN_DATA_PUSAT')){
        return 'Produsen Data Pusat'
      }
      else if(this.userRoles.includes('ROLE_PRODUSEN_DATA_PROVINSI')){
        return 'Produsen Data Provinsi'
      }
      else{
        return 'Produsen Data Kabupaten/Kota'
      }
      
    }
  },
  
 async mounted() {
    this.getUserInfo(this.$store.getters["auth/user"])
    this.currentDate = new Date();
    await this.setUpSetting();
    if(this.isDeadlineSubmissionWarnShowed){
      window.setInterval(() => {this.currentDate = new Date()}, 1000)
    }
  },
  methods:{
    getUserInfo(user){
      this.user = {
        name : user.name,
        username: user.username,
        email: user.email,
        division: null,
        organization: user.sdiOrganization ? {
          id: user.sdiOrganization.id,
          name: user.sdiOrganization.name,
          address: user.sdiOrganization.details.address,
          province: user.sdiOrganization.details.province,
          city: user.sdiOrganization.details.city,
        } : null,
      },
      this.userRoles = user.role.slice(1,-1).split(", ");
    },
    async setUpSetting(){
      await SettingService.getSdsSettings().then(
        (result)=>{
          this.deadlineDate = result.data.body.filter(x=>x.property == 'submission_deadline');
          this.deadlineDate = this.deadlineDate.length> 0 ? new Date(this.deadlineDate[0].value) : null;
        },
        (error)=>{
            console.log(error)
        }
      )
      
    },
  }
}

</script>
